import React from 'react'

interface CurrentTimeLineProps {
  position: number // minutes from midnight
  currentDayOfWeek?: number // 1-7 (Monday to Sunday)
}

const CurrentTimeLine: React.FC<CurrentTimeLineProps> = ({ position, currentDayOfWeek }) => {
  // Calculate the day index (0-6) for CSS positioning
  const dayIndex = currentDayOfWeek ? currentDayOfWeek - 1 : 0
  // Position within the days container (no time column offset here)
  const leftPosition = (dayIndex * (100 / 7))

  const style: React.CSSProperties = {
    top: `${position}px`,
    zIndex: 100,
    pointerEvents: 'none',
    position: 'absolute',
    left: 0,
    right: 0
  }

  // Create line segment for past time (before current day)
  const pastLineStyle: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    left: 0,
    right: `${leftPosition}%`,
    height: '2px',
    backgroundColor: 'rgba(245, 74, 69, 0.3)', // Lighter red for past time
    transform: 'translateY(-50%)'
  }

  // Create line segment for current time from current day onwards
  const currentLineStyle: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    left: `${leftPosition}%`,
    right: 0,
    height: '2px',
    backgroundColor: 'rgb(245, 74, 69)', // Full red for current time
    transform: 'translateY(-50%)'
  }

  // Red dot positioned at current day
  const dotStyle: React.CSSProperties = {
    position: 'absolute',
    left: `${leftPosition}%`,
    top: '50%',
    transform: 'translateY(-50%)',
    width: '8px',
    height: '8px',
    backgroundColor: 'rgb(245, 74, 69)',
    borderRadius: '50%',
    border: '2px solid white',
    boxShadow: '0 0 4px rgba(245, 74, 69, 0.5)'
  }

  // 左端时间标签（红字），显示当前时间 HH:mm
  const timeLabelStyle: React.CSSProperties = {
    position: 'absolute',
    left: '-60px', // 放入时间轴区域（宽 60px）
    top: '50%',
    transform: 'translateY(-50%)',
    width: '60px',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '8px', // 与时间轴右侧间距一致
    color: 'rgb(245, 74, 69)',
    fontWeight: 600,
    fontSize: '14px',
    background: 'transparent',
    pointerEvents: 'none'
  }

  const now = new Date()
  const hh = String(now.getHours()).padStart(2, '0')
  const mm = String(now.getMinutes()).padStart(2, '0')
  const minuteVal = now.getMinutes()
  const hideLabel = Math.min(minuteVal, 60 - minuteVal) < 15

  return (
    <div className="current-time-line" style={style}>
      <div style={pastLineStyle} />
      <div style={currentLineStyle} />
      <div style={dotStyle} />
      {!hideLabel && <div style={timeLabelStyle}>{`${hh}:${mm}`}</div>}
    </div>
  )
}

export default CurrentTimeLine